import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var MicrophoneOff01 = function MicrophoneOff01(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M15 9.4V5c0-1.6568-1.3431-3-3-3-1.1776 0-2.1967.6785-2.6878 1.666M12 19v3m0-3c-3.866 0-7-3.134-7-7v-2m7 9c3.866 0 7-3.134 7-7v-2M8 22h8M2 2l20 20m-10-7c-1.6569 0-3-1.3431-3-3V9l5.1226 5.12c-.543.5437-1.2935.88-2.1226.88"
    })
  }));
};
export default MicrophoneOff01;